import {HandType} from "../../global/types/GlobalTypes";

/* eslint-disable no-unused-vars */
export enum NoteStatus {
  DISABLED,
  OFF,
  ON,
  HOLD,
  DETACHED,
}

export interface Note {
  key: number;
  hand: HandType;
  finger: string;
  noteStatus: number;
  duration: number;
  name: {
    FR: string;
    EN: string;
  };
}

export function isAnAttackNote(note: NoteStatus): boolean {
  return note === NoteStatus.ON || note === NoteStatus.DETACHED;
}
